import { State } from '../../types';

export const nevada: State = {
  name: 'Nevada',
  abbreviation: 'NV',
  terms: [
    {
      word: 'Creosote',
      phonetic: 'KREE-uh-soht',
      description: 'The creosote bush, common in Southwestern deserts. Often mispronounced as "KREE-oh-soht."'
    },
    {
      word: 'Ely',
      phonetic: 'EE-lee',
      // audioUrl: '/audio/ely.mp3',
      description: 'A city in White Pine County, often mispronounced as "Ellie" or "Eli."'
    },
    {
      word: 'Hiko',
      phonetic: 'HIKE-oh',
      // audioUrl: '/audio/hiko.mp3',
      description: 'A small community in Lincoln County, pronounced "HIKE-oh" instead of "HICK-oh."'
    },
    {
      word: 'Mina',
      phonetic: 'MINE-uh',
      // audioUrl: '/audio/mina.mp3',
      description: 'A community in Mineral County, pronounced "MINE-uh" instead of "MEE-nah."'
    },
    {
      word: 'Moapa',
      phonetic: 'moh-AH-pah',
      // audioUrl: '/audio/moapa.mp3',
      description: 'A town in Clark County, sometimes mispronounced as "MOH-ap-uh."'
    },
    {
      word: 'Nevada',
      phonetic: 'nuh-VAD-uh',
      // audioUrl: '/audio/nevada.mp3',
      description: 'The state name is often mispronounced as "nuh-VAH-duh." The correct pronunciation uses a short "a" sound, as in "cat."'
    },
    {
      word: 'Owyhee',
      phonetic: 'oh-WYE-hee',
      // audioUrl: '/audio/owyhee.mp3',
      description: 'A town in northern Nevada, pronounced similarly to "Hawaii."'
    },
    {
      word: 'Palo Verde',
      phonetic: 'PAH-loh VEHR-day',
      description: 'A common Southwestern desert tree name. Often mispronounced as "PAL-oh VER-dee."'
    },
    {
      word: 'Pahranagat',
      phonetic: 'puh-RAN-uh-gat',
      // audioUrl: '/audio/pahranagat.mp3',
      description: 'A valley and wildlife refuge, often mispronounced due to its unique spelling.'
    },
    {
      word: 'Pahrump',
      phonetic: 'puh-RUMP',
      audioUrl: '/audio/pahrump.mp3',
      description: 'City in southern Nevada'
    },
    {
      word: 'Pioche',
      phonetic: 'pee-OACH',
      // audioUrl: '/audio/pioche.mp3',
      description: 'A town in Lincoln County, pronounced "pee-OACH" instead of "pee-OH-shay."'
    }
  ]
};